// src/hooks/useIsAdmin.ts
import { useAuth } from '@/contexts/AuthContext';

/**
 * Hook to check if the current user has admin role
 * Admin users are identified by having profile.user_type = 'admin'
 */
export function useIsAdmin() {
  const { profile, loading: authLoading } = useAuth();

  const isAdmin = profile?.user_type === 'admin';

  return {
    isAdmin,
    isLoading: authLoading,
    error: null,
  };
}